import {
    FormEngineAdvancedFormSelect,
    FormEngineAdvancedFormSelectProps,
} from '@form-engine/core-application/components/select/advanced';
import classNames from '@form-engine/core-util/class-names';
import { forwardRef } from 'react';

export const BuilderAdvancedFormSelect = forwardRef(
    (props: FormEngineAdvancedFormSelectProps, ref) => (
        <FormEngineAdvancedFormSelect
            {...props}
            className={classNames(props.className, 'fe-builder-select')}
            ref={ref}
        />
    )
);

BuilderAdvancedFormSelect.displayName = 'BuilderAdvancedFormSelect';
